import { ETAB_ROUTES } from "@etab/config";
import { META_SHOW_SUBHEADER } from "@core/constants";

import DocumentManagerRoot from "./DocumentManager.root.vue";
import DocumentsPage from "./Documents.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.account.documents.root.path,
      name: ETAB_ROUTES.account.documents.root.name,
      redirect: { name: ETAB_ROUTES.account.documents.slug.name, params: { documentSlug: "menu" } },
      meta: { [META_SHOW_SUBHEADER]: true },
      component: DocumentManagerRoot,
      children: [
        {
          path: ETAB_ROUTES.account.documents.slug.path,
          name: ETAB_ROUTES.account.documents.slug.name,
          component: DocumentsPage,
        },
      ],
    },
  ];
}
